import clsx from "clsx";
import { IPage } from "@/types/page";

export const InpageNav = ({
  title,
  pages,
  currentPageId,
}: {
  title?: string;
  pages: IPage[];
  currentPageId: string;
}) => {
  return (
    <div className={clsx("space-y-6 border-t pt-20 mt-16 -mx-16 px-16")}>
      <p className="font-semibold text-xl">{title || "Dans cette page"}</p>
      <div className="flex">
        <div className="h-1 w-10 bg-brand-red" />
      </div>
      <div className="grid xl:grid-cols-2 gap-4 _grid-rows-5 _grid-flow-col">
        {pages
          .filter((page: IPage) => !page.hidePageFromCorporateNav)
          .map((page: IPage) => (
            <a
              key={`inpage-nav-${page.sys.id}`}
              href={`/etablissement/${page.slug}`}
              className={clsx(
                "block hover:text-brand-blue hover:underline",
                currentPageId === page.sys.id
                  ? "font-bold text-brand-red pointer-events-none"
                  : "font-normal"
              )}
            >
              {page.title}
            </a>
          ))}
      </div>
    </div>
  );
};
